import React from 'react';
import { FormattedHTMLMessage, InjectedIntlProps, injectIntl } from 'react-intl';
import {
    setFocus,
    logger,
    FormFieldComponentProps,
    FormSelectChoice,
}
from '@sheerid/jslib';
import { SelectComponent } from '../../FormInputs/Select/SelectComponent';

export const GraduationDateComponent = ({
    onChange,
    intl,
    isErrored,
    value,
    errorId,
}: FormFieldComponentProps & InjectedIntlProps) => {
    const graduationDateParts = value.split('-');
    const graduationDateYear = Number.parseInt(graduationDateParts[0], 10) || undefined;
    const graduationDateMonth = Number.parseInt(graduationDateParts[1], 10) || undefined;

    const thisYear = new Date().getFullYear();
    const maxGraduationYear = thisYear + 4;

    const months: FormSelectChoice[] = [
        { value: '1', label: intl.formatMessage({ id: 'dateTime.january', defaultMessage: 'January' }) },
        { value: '2', label: intl.formatMessage({ id: 'dateTime.february', defaultMessage: 'February' }) },
        { value: '3', label: intl.formatMessage({ id: 'dateTime.march', defaultMessage: 'March' }) },
        { value: '4', label: intl.formatMessage({ id: 'dateTime.april', defaultMessage: 'April' }) },
        { value: '5', label: intl.formatMessage({ id: 'dateTime.may', defaultMessage: 'May' }) },
        { value: '6', label: intl.formatMessage({ id: 'dateTime.june', defaultMessage: 'June' }) },
        { value: '7', label: intl.formatMessage({ id: 'dateTime.july', defaultMessage: 'July' }) },
        { value: '8', label: intl.formatMessage({ id: 'dateTime.august', defaultMessage: 'August' }) },
        { value: '9', label: intl.formatMessage({ id: 'dateTime.september', defaultMessage: 'September' }) },
        { value: '10', label: intl.formatMessage({ id: 'dateTime.october', defaultMessage: 'October' }) },
        { value: '11', label: intl.formatMessage({ id: 'dateTime.november', defaultMessage: 'November' }) },
        { value: '12', label: intl.formatMessage({ id: 'dateTime.december', defaultMessage: 'December' }) },
    ];

    const selectableYears = [] as FormSelectChoice[];
    for (var i = thisYear; i <= maxGraduationYear; i++) {
        selectableYears.push({ value: i.toString(), label: intl.formatMessage({ id: i.toString(), defaultMessage: i.toString() })});
    }
    const updateGraduationMonth = (month: any) => {
        if (month === '' || month === null || month === undefined) {
            onChange(`${graduationDateYear}-`);
        }

        const newVal = Number.parseInt(month, 10);
        if (typeof newVal === 'number' && newVal >= 1 && newVal <= 12) {
            onChange(`${graduationDateYear}-${month}`);
        } else {
            logger.warn(`Value '${newVal}' is an invalid graduation month`);
        }
    };

    const updateGraduationYear = (year: any) => {
        if (year === '' || year === null || year === undefined) {
            onChange(`-${graduationDateMonth}`);
        }
        const newVal = Number.parseInt(year, 10);
        onChange(`${newVal}-${graduationDateMonth}`);
    };

    return (
        <div className="sid-field sid-graduationdate">
            <div className="sid-l-space-top-md" />
            <label htmlFor="sid-graduationdate__month">
                <div className="sid-field__label-with-explanation sid-l-space-btm-sm">
                    <div className="sid-field__label sid-field__label--required">
                        <FormattedHTMLMessage
                            id="graduationDate"
                            defaultMessage="Anticipated Graduation Date"
                        />
                    </div>
                    <div className="sid-field__label-explanation">
                        <FormattedHTMLMessage
                            id="verificationPurposesOnly"
                            defaultMessage="Used for verification purposes only"
                        />
                    </div>
                </div>
            </label>

            <div className="sid-graduation-date__inputs sid-text-input--required">
                <SelectComponent
                    className={'sid-graduationdate__month'}
                    isErrored={isErrored}
                    options={months}
                    onChange={
                        (choice: any) => {
                            if (choice) {
                                updateGraduationMonth(choice.value);
                                setFocus('graduationDateYear');
                            } else {
                                updateGraduationMonth(null);
                            }
                        }
                    }
                    placeholder={
                        intl.formatMessage({
                            id: 'step.personalInfo.graduationMonthPlaceholder',
                            defaultMessage: 'Month',
                        })
                    }
                    value={(graduationDateMonth ? months[graduationDateMonth - 1] : undefined)}
                />

                <SelectComponent
                    className={'sid-graduationdate__year'}
                    isErrored={isErrored}
                    options={selectableYears}
                    value={graduationDateYear ? selectableYears[graduationDateYear - 1] : undefined}
                    placeholder={
                        intl.formatMessage({
                            id: 'step.personalInfo.graduationYearPlaceholder',
                            defaultMessage: 'Year',
                        })
                    }
                    onChange={(choice: any) => {
                        if (choice) {
                            updateGraduationYear(choice.value);
                        } else {
                            updateGraduationYear(null);
                        }
                    }}
                />
            </div>

            {
                  isErrored ? (
                      errorId ? (
                        <div className="sid-field-error">
                            <FormattedHTMLMessage
                                id={`errorId.${errorId}`}
                                defaultMessage="Graduation Year is required"
                            />
                        </div>)
                        :
                        <div className="sid-field-error">
                            <FormattedHTMLMessage
                                id={`errorId.invalidError`}
                                defaultMessage="Invalid graduation year"
                            />
                        </div>
                ) : null
            }
        </div>
    );
};
GraduationDateComponent.defaultProps = {
    value: `1/${new Date().getFullYear()}`,
};

export const GraduationDate = injectIntl(GraduationDateComponent);
